import React from 'react';
import { useNavigate } from 'react-router-dom';
import { UserPlus, Ticket, Gift, MessageSquare, Users } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { isPro as checkIsPro } from '../../utils/planPermissions';

const QuickActionsGrid: React.FC = () => {
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const hasProAccess = checkIsPro(currentUser?.subscription);

  const actions = [
    { icon: UserPlus, label: 'Registrar cliente', sub: 'alta manual', to: '/dashboard/register-client' },
    { icon: Ticket, label: 'Canjear recompensa', sub: 'cliente en mostrador', to: '/dashboard/redeem-rewards' },
    { icon: Gift, label: 'Recompensas', sub: 'crear y editar', to: '/dashboard/rewards' },
    hasProAccess
      ? { icon: MessageSquare, label: 'Campañas', sub: 'WhatsApp masivo', to: '/dashboard/campaigns' }
      : { icon: Users, label: 'Lista de clientes', sub: 'busca y consulta', to: '/dashboard/clients' },
  ];

  return (
    <div>
      <h3 className="text-xs font-bold uppercase tracking-wider text-content-3 mb-2">Accesos rápidos</h3>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
        {actions.map(a => {
          const Icon = a.icon;
          return (
            <button
              key={a.to}
              type="button"
              onClick={() => navigate(a.to)}
              className="text-left rounded-full bg-[#0057B8] text-white shadow-sm shadow-[#0057B8]/20 px-4 py-3 flex items-center gap-3 hover:bg-[#004494] transition-colors"
            >
              <span className="flex-shrink-0 w-9 h-9 rounded-full bg-white/15 text-white flex items-center justify-center">
                <Icon className="h-5 w-5" />
              </span>
              <span className="min-w-0">
                <span className="block text-sm font-semibold text-white truncate">{a.label}</span>
                <span className="block text-[11px] text-white/75">{a.sub}</span>
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default QuickActionsGrid;
